import { getFormat, getHeight, getWidth, getViewingDirection } from '../../2.x/iiif/technical';

var getId = function getId(resource) {
  return resource.id;
};

var getType = function getType(resource) {
  return resource.type;
};

var getProfile = function getProfile(resource) {
  return resource.profile || null;
};

var getDuration = function getDuration(resource) {
  if (typeof resource.duration === 'string') {
    var attempt = parseFloat(resource.duration);
    // Is NaN
    if (attempt !== attempt) {
      return 0.0;
    }
    return attempt;
  }
  return 0 + resource.duration || 0.0;
};

var getBehavior = function getBehavior(resource) {
  return resource.behavior || null;
};

var getTimeMode = function getTimeMode(resource) {
  return resource.timeMode || null;
};

var getMotivation = function getMotivation(resource) {
  return resource.motivation || null;
};

export { getId, getType, getFormat, getProfile, getHeight, getWidth, getDuration, getViewingDirection, getBehavior, getTimeMode, getMotivation };